import '../../scss/trend/index.scss';
